import { createReducer } from 'app-webtech-core/reducers/createReducer';
import {
  CHANGE_SELECTED_GENRE,
  CHANGE_SELECTED_INDEX,
  HIDE_ITEM_DETAIL,
  PLAY_ITEM,
  SHOW_ITEM_DETAIL,
} from '../actions/types';
import { vodGuideHideItemDetailReducer } from './hideItemDetail';
import { vodGuideShowItemDetailReducer } from './showItemDetail';
import { vodGuidePlayItemReducer } from './playItem';
import { vodGuideChangeSelectedGenreReducer } from './changeSelectedGenre';
import { vodGuideChangeSelectedIndexReducer } from './changeSelectedIndex';

export const defaultState = {
  selectedGenre: 0,
  currentItemDetailId: null,
  currentItemId: null,
  selectedIndex: 0,
};

export const vodGuideReducer = createReducer(defaultState, {
  [SHOW_ITEM_DETAIL]: vodGuideShowItemDetailReducer,
  [HIDE_ITEM_DETAIL]: vodGuideHideItemDetailReducer,
  [PLAY_ITEM]: vodGuidePlayItemReducer,
  [CHANGE_SELECTED_GENRE]: vodGuideChangeSelectedGenreReducer,
  [CHANGE_SELECTED_INDEX]: vodGuideChangeSelectedIndexReducer,
});
